module.exports = new __parcel__URL__("image_zh-tw.42c90122.png").toString();